"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubitemsFieldLogic = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const google_sheet_1 = require("../../utils/google-sheet");
const intl_1 = require("../../locale/intl");
const migrations_1 = require("../../migrations/migrations");
const subitems_fieldtype_1 = require("../../safe-field-value/subitems-field/subitems.fieldtype");
const texts_1 = require("../../texts");
const permission_1 = require("../../utils/permission");
const validation_1 = require("../../validation/validation");
class SubitemsFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "subitemsfield";
        this.label = (0, intl_1.$t)(texts_1.subitemsFieldText.sub_items);
        this.icon = "journal";
        this.iconColor = "#3A86FF";
        this.placeholder = (0, intl_1.$t)(texts_1.subitemsFieldText.enter_number_here);
        this.description = (0, intl_1.$t)(texts_1.subitemsFieldText.create_itemized_line_items_in_a_record);
        this.singleExportEligible = true;
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.subitemsFieldText.table),
            (0, intl_1.$t)(texts_1.subitemsFieldText.form),
            (0, intl_1.$t)(texts_1.subitemsFieldText.list),
            (0, intl_1.$t)(texts_1.subitemsFieldText.questionnaire),
        ];
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_equal_to: comparisons_1.isEqualTo,
            is_not_equal_to: comparisons_1.isNotEqualTo,
            is_greater_than: comparisons_1.isGreaterThan,
            is_less_than: comparisons_1.isLessThanAndNotEmpty,
            is_equal_or_greater_than: comparisons_1.isEqualOrGreaterThan,
            is_equal_or_less_than: comparisons_1.isEqualOrLessThanAndNotEmpty,
            is_empty: comparisons_1.isObjectFieldEmpty,
            is_not_empty: comparisons_1.isNotObjectFieldEmpty,
        };
        this.fieldValueGetter = new subitems_fieldtype_1.SubItemsFieldValueGetter();
        this.migrationRules = {
            // temporary solution to not migrate subitems value.
            // Proper migration will be implemented in task SMS-37264
            subitemsfield: migrations_1.noopMigrateFunc,
        };
    }
    get validators() {
        const uniqueValidator = (0, validation_1.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return { required: validation_1.required, unique: uniqueValidator };
    }
    valueToString(fieldValue) {
        if (!fieldValue) {
            return "0";
        }
        return fieldValue.count.toString();
    }
    valueToGoogleSheet(fieldValue) {
        var _a;
        return (0, google_sheet_1.makeRowDataValues)((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.count) !== null && _a !== void 0 ? _a : 0, "numberValue");
    }
    valueToExcelExport(fieldValue) {
        var _a;
        const value = (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.count) !== null && _a !== void 0 ? _a : 0;
        return {
            t: "n",
            v: String(value),
        };
    }
    processFilterValue(filterValue) {
        return filterValue && +filterValue;
    }
    processFieldValue(record, slug, comparison, field) {
        var _a;
        const fieldValue = super.processFieldValue(record, slug, comparison, field);
        return (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.count) !== null && _a !== void 0 ? _a : 0;
    }
    canHaveReferencedRecords() {
        return true;
    }
    getReferencedRecords(fieldValue, field) {
        var _a;
        if (!fieldValue || fieldValue.count === 0 || !fieldValue.items) {
            return [];
        }
        // Nested fields must be extracted
        const extractFieldTypes = ["linkedrecordfield"];
        const subitemRecordsStructure = (_a = field.params.structure) === null || _a === void 0 ? void 0 : _a.filter((subitemField) => extractFieldTypes.includes(subitemField.field_type));
        if (!subitemRecordsStructure) {
            return [];
        }
        const requests = [];
        subitemRecordsStructure.map((recordStructure) => {
            var _a;
            return (_a = fieldValue.items) === null || _a === void 0 ? void 0 : _a.forEach((subitemRecord) => {
                const nestedSubitemIDs = subitemRecord[recordStructure.slug] || [];
                nestedSubitemIDs.forEach((recordID) => {
                    requests.push({
                        recordId: recordID,
                        application_id: recordStructure.params.linked_application,
                    });
                });
            });
        });
        return requests;
    }
    sortKey(fieldValue) {
        var _a;
        return (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.count) !== null && _a !== void 0 ? _a : 0;
    }
    useNaturalSorting(field, fieldValue, isGroupByRule) {
        return false;
    }
    getEmptyValue() {
        return { count: 0 };
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editorWidth: "100%",
            allowAddRecordToGroup: false,
        };
    }
    getGroupValues(fieldValue) {
        if (!fieldValue) {
            return [];
        }
        return [fieldValue];
    }
    isFullValueLoadNeeded(fieldValue) {
        return !fieldValue || fieldValue.count > 0;
    }
    isPartialValue(fieldValue) {
        return !!fieldValue && !("items" in fieldValue);
    }
    isValueEmpty(fieldValue) {
        return !fieldValue || fieldValue.count === 0;
    }
    isValueEqual(fieldValue1, fieldValue2) {
        return (0, react_fast_compare_1.default)(fieldValue1, fieldValue2);
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            contentAlignment: "centered",
        };
    }
    getNestedFields(field) {
        var _a;
        return (_a = field.params.structure) !== null && _a !== void 0 ? _a : [];
    }
    filterValueToString(filterValue, _field, _userPreferences, _comparison) {
        return filterValue;
    }
    canChangeValue(_field, _fromValue, _toValue) {
        return false;
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    serializeField(field) {
        var _a;
        const serialized = super.serializeField(field);
        const structure = (_a = field.params.structure) === null || _a === void 0 ? void 0 : _a.map((childField) => super.serializeField(childField));
        return {
            ...serialized,
            params: { ...serialized.params, structure },
        };
    }
    getEditRecordInputMenuActions(_field, memberAccess) {
        if ((0, permission_1.isSolutionOwner)(memberAccess)) {
            return [
                {
                    action: "editDisplay",
                    icon: "eye",
                    text: (0, intl_1.$t)(texts_1.subitemsFieldText.edit_display),
                },
            ];
        }
        return [];
    }
    getDefaultValue() {
        return { count: 0, items: [] };
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.SubitemsFieldLogic = SubitemsFieldLogic;
